/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
 Controller,
 FieldErrors,
 useController,
 FieldValues,
} from 'react-hook-form'
import Select, {components} from 'react-select'
import {ErrorMessage} from '@hookform/error-message'
import {KTSVG} from 'helpers'
import {KTText} from '../KTText'
import {useTranslation} from 'react-i18next'

const {ValueContainer, Placeholder} = components

const CheckboxOption = (props: any) => {
 return (
  <components.Option {...props}>
   <div className='flex items-center gap-2'>
    <input
     type='checkbox'
     checked={props.isSelected}
     onChange={() => null}
     className='w-4 h-4 accent-[#4E83E4] cursor-pointer flex-shrink-0'
    />
    <span>{props.label}</span>
   </div>
  </components.Option>
 )
}

const RadioOption = (props: any) => {
 return (
  <components.Option {...props}>
   <div className='flex items-center gap-2'>
    <input
     type='radio'
     checked={props.isSelected}
     onChange={() => null}
     className='w-4 h-4 accent-[#4E83E4] cursor-pointer flex-shrink-0'
    />
    <span>{props.label}</span>
   </div>
  </components.Option>
 )
}

const Input = (props: any) => {
 return <components.Input {...props} autoComplete='false' />
}

const customStyles = {
 valueContainer: (provided: any) => ({
  ...provided,
  overflow: 'visible',
  minHeight: '1px',
  paddingTop: '0',
  paddingBottom: '0',
 }),
 placeholder: (provided: any, state: any) => ({
  ...provided,
  position: 'absolute',
  top:
   state?.hasValue || state.selectProps?.inputValue
    ? -15
    : '10%',
  transition: 'top 0.1s, font-size 0.1s',
  ...((state?.hasValue ||
   state.selectProps?.inputValue) && {
   backgroundColor: '#fff',
   fontSize: '12px !important',
   fontWeight: '500',
  }),
  padding: '0 5px 0 5px',
 }),
}

interface Props {
 label?: string
 required?: boolean
 id?: string
 name: string
 disabled?: boolean
 value?: string | number
 default?: string | number
 autoComplete?: string
 errorText?: string
 errorKey?: string
 testId?: string
 className?: string
 wrapperClassName?: string
 inputWrapperClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
 placeholder?: string
 OptionLabelKey: string
 OptionValueKey: string
 autofocus?: boolean
 isMultiselect?: boolean
 rules?: any
 data: FieldValues
 control?: any
 movePlaceholderToTop?: boolean
 showNumberAfterRecords?: boolean
 config?: FieldValues | undefined
 errors?: FieldErrors | undefined
 customStyle?: FieldValues | undefined
 singleValue?: FieldValues | undefined
 isLoading?: boolean
 isClearable?: boolean
 isSearchable?: boolean
 menuPortalTarget?: HTMLElement | null
 showCheckbox?: boolean
 showRadio?: boolean
 styles?: any
}

let movePlaceholder = false
let showNumber = false

const CustomValueContainer = ({
 children,
 ...props
}: any) => {
 let [values, input] = children as any
 if (showNumber && Array.isArray(values)) {
  const val = (i: number) => values[i].props.children
  const {length} = values

  switch (length) {
   case 1:
    values = `${val(0)}`
    break
   default:
    values = `${val(0)} + (${length - 1})`
    break
  }
 }

 return (
  <ValueContainer {...props}>
   {movePlaceholder && (
    <Placeholder {...props} isFocused={props.isFocused}>
     {props.selectProps.placeholder}
    </Placeholder>
   )}
   {/* {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )} */}
   {values}
   {input}
  </ValueContainer>
 )
}

const Select2DropdownField = (props: any) => {
 const {
  label,
  className,
  wrapperClassName,
  labelClassName,
  name,
  required,
  data,
  id,
  disabled = false,
  showIcon = false,
  menuPortalTarget,
  iconPath,
  errorIconClassName,
  inputWrapperClassName,
  rules,
  placeholder,
  OptionLabelKey,
  OptionValueKey,
  isMultiselect,
  control,
  value,
  movePlaceholderToTop = false,
  showNumberAfterRecords = false,
  isLoading = false,
  isClearable = true,
  isSearchable = true,
  config,
  errors,
  customStyle,
  singleValue,
  helperTextClass,
  helperText,
  showCheckbox = false,
  showRadio = false,
  styles,
 }: Props = props
 const {t} = useTranslation()
 showNumber = showNumberAfterRecords
 movePlaceholder = movePlaceholderToTop
 const getValue = (
  value: any,
  optionKey: string,
  isMulti = false
 ) => {
  if (value) {
   if (isMulti) {
    const arr: any = []
    // eslint-disable-next-line array-callback-return
    value.map((v: any) => {
     arr.push(v[optionKey])
    })
    return arr
   } else {
    return value[optionKey]
   }
  } else {
   return value
  }
 }

 const getDefaulltValue = (
  value: any,
  optionKey: string,
  isMulti = false
 ) => {
  const hasValue =
   value !== undefined && value !== null && value !== ''
  if (data && data.length > 0 && hasValue) {
   if (isMulti) {
    const arr: any = []
    data.map((v: any) => {
     if (
      value.some(
       (v2: any) => String(v2) === String(v[optionKey])
      )
     ) {
      arr.push(v)
     }
    })
    return arr
   } else {
    return data.find(
     (c: any) => String(c[optionKey]) === String(value)
    )
   }
  } else {
   return ''
  }
 }

 return (
  <div className={`${wrapperClassName}`}>
   <div
    className={`${inputWrapperClassName} ${
     disabled && '!bg-[#F5F8FA]'
    } form-field-wrapper relative rounded-lg bg-white focus-within:border-[#000000] rounded-lg border border-solid border-[#E6EBF0] bg-white focus-within:border-[#000000]`}
   >
    {label && (
     <label
      htmlFor={id}
      className={`input-label ${labelClassName} relative pb-1 text-[#4E83E4] text-xs font-medium`}
     >
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </label>
    )}
    <Controller
     control={control}
     rules={rules}
     name={name}
     render={({field}) => {
      const {onChange, onBlur, value, name, ref} = field
      return (
       <Select
        hideSelectedOptions={!showNumberAfterRecords}
        onBlur={onBlur}
        ref={ref}
        menuPortalTarget={menuPortalTarget}
        value={getDefaulltValue(
         value,
         OptionValueKey,
         isMultiselect
        )}
        className={`${className} !disabled:text-[#33393D] text-[#33393D] basic-multi-select text-[16px] font-medium input-wrapper`}
        classNamePrefix='select'
        defaultValue={getDefaulltValue(
         value,
         OptionValueKey,
         isMultiselect
        )}
        isDisabled={disabled}
        placeholder={placeholder}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isMulti={isMultiselect}
        name={name}
        id={id ?? name}
        getOptionLabel={(item: any) => item[OptionLabelKey]}
        getOptionValue={(item: any) => item[OptionValueKey]}
        options={data}
        noOptionsMessage={() => t('common.noOptions')}
        onChange={(event: any) => {
         onChange(
          getValue(event, OptionValueKey, isMultiselect)
         ) // data send back to hook form
        }}
        styles={{
         ...(movePlaceholderToTop
          ? customStyles
          : {
             control: (base: any) => ({
              ...base,
              ...customStyle,
             }),
             singleValue: (base: any) => ({
              ...base,
              ...singleValue,
             }),
            }),
         ...styles,
         menuPortal: (base: any) => ({
          ...base,
          ...(styles?.menuPortal
           ? styles.menuPortal(base)
           : {}),
          zIndex: 99999,
         }),
         menu: (base: any) => ({
          ...base,
          ...(styles?.menu ? styles.menu(base) : {}),
          zIndex: 99999,
         }),
        }}
        components={{
         ValueContainer: CustomValueContainer,
         Input,
         ...(showCheckbox && {Option: CheckboxOption}),
         ...(showRadio && {Option: RadioOption}),
        }}
        {...config}
       />
      )
     }}
    />
    {(errors?.[name] ?? showIcon) && (
     <KTSVG
      path={`${iconPath ?? '/media/icons/icon_error.svg'}`}
      svgClassName={`${errorIconClassName} absolute bottom-[30%] z-11 right-[35px]`}
     />
    )}
   </div>
   {helperText && !errors?.[name] && (
    <KTText className={helperTextClass}>
     {helperText}
    </KTText>
   )}
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {Select2DropdownField}
